import { InjectionToken } from '@angular/core';
import type { EqAuthEnvironment } from '@env/environment.model';

export type { EqAuthEnvironment } from '@env/environment.model';

export const EQAUTH_ENV = new InjectionToken<EqAuthEnvironment>('EQAUTH_ENV');
